/* Crowd Designs: slow "silk and thread" background. Flowing warp threads, a fine twill weave and running stitches. */
(function () {
  'use strict';
  if (window.__fabricBg) return; window.__fabricBg = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var c = document.createElement('canvas');
  c.className = 'fabric-bg'; c.setAttribute('aria-hidden', 'true');
  document.body.insertBefore(c, document.body.firstChild);
  var ctx = c.getContext('2d'); if (!ctx) return;
  var S = 0.7, W = 0, H = 0, pat = null, last = 0, running = false;

  function tile() {
    var t = document.createElement('canvas'); t.width = t.height = 20; var x = t.getContext('2d');
    x.lineCap = 'butt';
    x.strokeStyle = 'rgba(255,255,255,0.075)'; x.lineWidth = 1.6;
    for (var i = -20; i <= 40; i += 5) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i + 20, 20); x.stroke(); }
    x.strokeStyle = 'rgba(0,0,0,0.22)'; x.lineWidth = 1.2;
    for (var j = -20; j <= 40; j += 5) { x.beginPath(); x.moveTo(j + 2.5, 0); x.lineTo(j + 22.5, 20); x.stroke(); }
    return t;
  }
  function resize() {
    W = Math.max(2, Math.round(window.innerWidth * S)); H = Math.max(2, Math.round(window.innerHeight * S));
    c.width = W; c.height = H; pat = ctx.createPattern(tile(), 'repeat');
  }
  var N = 46;
  function yAt(i, x, t) {
    var A = H * 0.085, base = (i / (N - 1)) * H * 1.30 - H * 0.15;
    var k = 0.6 + 0.4 * Math.sin(i * 0.21 + t * 0.10);
    return base + A * k * (Math.sin(x * 0.0042 / S * 0.7 + t * 0.22 + i * 0.105) + 0.55 * Math.sin(x * 0.0093 / S * 0.7 - t * 0.17 + i * 0.062));
  }
  function draw(t) {
    ctx.clearRect(0, 0, W, H);
    // soft red and silver light behind the cloth
    var g = ctx.createRadialGradient(W * 0.78, H * 0.12, 4, W * 0.78, H * 0.12, H * 0.95);
    g.addColorStop(0, 'rgba(200,16,46,0.12)'); g.addColorStop(1, 'rgba(200,16,46,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    var g2 = ctx.createRadialGradient(W * 0.10, H * 0.95, 4, W * 0.10, H * 0.95, H * 0.8);
    g2.addColorStop(0, 'rgba(200,205,220,0.06)'); g2.addColorStop(1, 'rgba(200,205,220,0)'); ctx.fillStyle = g2; ctx.fillRect(0, 0, W, H);
    // fine twill weave that drifts slowly
    ctx.save(); ctx.translate((t * 5) % 20, (t * 2.5) % 20); ctx.globalAlpha = 0.55; ctx.fillStyle = pat; ctx.fillRect(-20, -20, W + 40, H + 40); ctx.restore();
    // warp threads (silk folds)
    var scroll = (window.pageYOffset || 0) * 0.10 * S;
    ctx.save(); ctx.translate(0, -(scroll % (H * 0.06)));
    ctx.lineWidth = 1 * S + 0.3;
    for (var i = 0; i < N; i++) {
      var hi = (i % 9 === 4) ? 2 : (i % 5 === 1) ? 1 : 0;
      ctx.strokeStyle = hi === 2 ? 'rgba(230,50,74,0.16)' : hi === 1 ? 'rgba(225,230,240,0.11)' : 'rgba(255,255,255,0.052)';
      ctx.beginPath();
      for (var x = 0; x <= W; x += 9) { var y = yAt(i, x, t); if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y); }
      ctx.stroke();
    }
    // running stitches sewn along three of the threads
    [[9, 'rgba(230,235,245,0.26)'], [24, 'rgba(255,70,92,0.34)'], [38, 'rgba(230,235,245,0.20)']].forEach(function (d, k) {
      ctx.save(); ctx.setLineDash([12 * S, 9 * S]); ctx.lineDashOffset = -t * (26 + k * 6) * S; ctx.lineWidth = 1.6 * S + 0.2; ctx.strokeStyle = d[1];
      ctx.beginPath();
      for (var x = 0; x <= W; x += 9) { var y = yAt(d[0], x, t) + 5 * S; if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y); }
      ctx.stroke(); ctx.restore();
    });
    ctx.restore();
    // keep edges calm so text stays crisp
    var v = ctx.createLinearGradient(0, 0, 0, H); v.addColorStop(0, 'rgba(8,8,10,0.45)'); v.addColorStop(0.25, 'rgba(8,8,10,0)'); v.addColorStop(0.75, 'rgba(8,8,10,0)'); v.addColorStop(1, 'rgba(8,8,10,0.5)');
    ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  }
  function frame(now) {
    if (!running) return;
    if (now - last > 33) { last = now; draw(now / 1000); }
    requestAnimationFrame(frame);
  }
  function start() { if (running || reduced) return; running = true; requestAnimationFrame(frame); }
  function stop() { running = false; }
  resize(); draw(4);
  window.addEventListener('resize', function () { resize(); draw(4); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  start();
})();
